"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "conflenti": {
    "0c2ce8b8": [{
      "hkey": "9fb75cbe",
      "slug": "conflenti",
      "name": "Conflenti",
      "primary": true,
      "skipSearch": false
    }],
    "abritti": [{
      "hkey": "9fb75cbe",
      "slug": "conflenti",
      "name": "Conflenti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e52ee4f7": [{
      "hkey": "9fb75cbe",
      "slug": "conflenti",
      "name": "Conflenti",
      "primary": true,
      "skipSearch": false
    }],
    "annetta": [{
      "hkey": "9fb75cbe",
      "slug": "conflenti",
      "name": "Conflenti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7d40e2d5": [{
      "hkey": "9fb75cbe",
      "slug": "conflenti",
      "name": "Conflenti",
      "primary": true,
      "skipSearch": false
    }],
    "augurelli": [{
      "hkey": "9fb75cbe",
      "slug": "conflenti",
      "name": "Conflenti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fd9644e9": [{
      "hkey": "9fb75cbe",
      "slug": "conflenti",
      "name": "Conflenti",
      "primary": true,
      "skipSearch": false
    }],
    "calusci": [{
      "hkey": "9fb75cbe",
      "slug": "conflenti",
      "name": "Conflenti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "eac478b7": [{
      "hkey": "9fb75cbe",
      "slug": "conflenti",
      "name": "Conflenti",
      "primary": true,
      "skipSearch": false
    }],
    "caria": [{
      "hkey": "9fb75cbe",
      "slug": "conflenti",
      "name": "Conflenti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f0adad8a": [{
      "hkey": "9fb75cbe",
      "slug": "conflenti",
      "name": "Conflenti",
      "primary": true,
      "skipSearch": false
    }],
    "ceraso": [{
      "hkey": "9fb75cbe",
      "slug": "conflenti",
      "name": "Conflenti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3b2eb72d": [{
      "hkey": "2e041a5f",
      "slug": "san-mazzeo-costa",
      "name": "San Mazzeo Costa",
      "primary": true,
      "skipSearch": false
    }],
    "costa": [{
      "hkey": "2e041a5f",
      "slug": "san-mazzeo-costa",
      "name": "San Mazzeo Costa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "9a1fd6d4": [{
      "hkey": "4d801952",
      "slug": "san-mazzeo-sciosci-coscaro-stranges",
      "name": "San Mazzeo Sciosci-Coscaro-Stranges",
      "primary": true,
      "skipSearch": false
    }],
    "croscaro": [{
      "hkey": "4d801952",
      "slug": "san-mazzeo-sciosci-coscaro-stranges",
      "name": "San Mazzeo Sciosci-Coscaro-Stranges",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "conflenti"
    }],
    "ca94c770": [{
      "hkey": "9fb75cbe",
      "slug": "conflenti",
      "name": "Conflenti",
      "primary": true,
      "skipSearch": false
    }],
    "lisca": [{
      "hkey": "9fb75cbe",
      "slug": "conflenti",
      "name": "Conflenti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f17da66e": [{
      "hkey": "9fb75cbe",
      "slug": "conflenti",
      "name": "Conflenti",
      "primary": true,
      "skipSearch": false
    }],
    "passo": [{
      "hkey": "9fb75cbe",
      "slug": "conflenti",
      "name": "Conflenti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8343446d": [{
      "hkey": "9fb75cbe",
      "slug": "conflenti",
      "name": "Conflenti",
      "primary": true,
      "skipSearch": false
    }],
    "querciola": [{
      "hkey": "9fb75cbe",
      "slug": "conflenti",
      "name": "Conflenti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3b6fbb44": [{
      "hkey": "4d801952",
      "slug": "san-mazzeo-sciosci-coscaro-stranges",
      "name": "San Mazzeo Sciosci-Coscaro-Stranges",
      "primary": true,
      "skipSearch": false
    }],
    "sciosci": [{
      "hkey": "4d801952",
      "slug": "san-mazzeo-sciosci-coscaro-stranges",
      "name": "San Mazzeo Sciosci-Coscaro-Stranges",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "2515edd6": [{
      "hkey": "4d801952",
      "slug": "san-mazzeo-sciosci-coscaro-stranges",
      "name": "San Mazzeo Sciosci-Coscaro-Stranges",
      "primary": true,
      "skipSearch": false
    }],
    "stranges": [{
      "hkey": "4d801952",
      "slug": "san-mazzeo-sciosci-coscaro-stranges",
      "name": "San Mazzeo Sciosci-Coscaro-Stranges",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "conflenti"
    }],
    "3d3add25": [{
      "hkey": "7da36c24",
      "slug": "san-mazzeo-vallone-cupo",
      "name": "San Mazzeo Vallone Cupo",
      "primary": true,
      "skipSearch": false
    }],
    "vallone-cupo": [{
      "hkey": "7da36c24",
      "slug": "san-mazzeo-vallone-cupo",
      "name": "San Mazzeo Vallone Cupo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;